export default class FrontendDetectionHelper {
}
FrontendDetectionHelper.isFrontend = false;
